import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { Option, Record as EffectRecord } from 'effect'

import { renamePendingKey } from '../domain/pendingId'
import { sessionIdAssigned } from './pendingId'

// 会話の対象の view を、会話と同じく AgentWidget の useReducer に持つ（ADR-104）。対象の決め方は domain/chatTarget.ts で決める

// チャットごとの対象の view の id。キーは agentSessionId（作る前は仮の ID。domain/pendingId.ts）。対象のないチャットは持たない
type AgentTargetsState = Readonly<Record<string, string>>

const INITIAL_AGENT_TARGETS_STATE: AgentTargetsState = {}

export const chatTargetOf = (state: AgentTargetsState, agentSessionId: string): string | null =>
  Option.getOrNull(EffectRecord.get(state, agentSessionId))

export const agentTargetsSlice = createSlice({
  name: 'agentTargets',
  initialState: INITIAL_AGENT_TARGETS_STATE,
  reducers: {
    // chooseTargetViewId（domain/chatTarget.ts）で決めた対象を、そのチャットに覚える
    targetChosen: (state, action: PayloadAction<{ agentSessionId: string; viewId: string }>) =>
      EffectRecord.set(state, action.payload.agentSessionId, action.payload.viewId),
    // BE が対象の view を見つけられなかった（VIEW_NOT_FOUND）。会話の途中でアーカイブされたり見られなくなったりした view は、
    // 送り続けるとそのチャットの指示がすべて断られるので、以後は対象なしで送る
    targetViewNotFound: (state, action: PayloadAction<{ agentSessionId: string }>) =>
      EffectRecord.remove(state, action.payload.agentSessionId),
  },
  extraReducers: (builder) => {
    builder.addCase(sessionIdAssigned, (state, action) =>
      renamePendingKey(state, action.payload.pendingSessionId, action.payload.agentSessionId),
    )
  },
})

export const { targetChosen, targetViewNotFound } = agentTargetsSlice.actions
